<template>
    <v-dialog v-model="open" persistent width="400" scrollable>
        <v-card>
            <v-toolbar dense outlined flat>
                <span v-if="meter_id">Editar medidor</span>
                <span v-else>Nuevo medidor</span>
            </v-toolbar>
            <v-card-text class="pt-6 text-center" style="max-height: 70vh">
                <v-text-field
                    v-model="meter.id"
                    label="Id medidor"
                    :disabled="meter_id != null"
                    outlined
                    flat
                    dense
                    solo
                    hide-details
                ></v-text-field>
                <v-text-field
                    v-model="meter.name"
                    label="Nombre"
                    class="mt-3"
                    outlined
                    flat
                    dense
                    solo
                    hide-details
                ></v-text-field>
                <v-select
                    v-model="meter.type"
                    label="Tipo"
                    :items="[
                        { text: 'Consumo', value: 'consumption' },
                        { text: 'Generacion', value: 'generation' },
                    ]"
                    class="mt-3"
                    outlined
                    flat
                    dense
                    solo
                    hide-details
                />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined class="mr-2" small @click="close">
                    Cancelar
                </v-btn>
                <v-btn
                    color="accent"
                    small
                    :disabled="
                        meter.id === '' ||
                        meter.name === '' ||
                        meter.type === null
                    "
                    @click="save"
                    :loading="loading"
                >
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'MetersDialog',
    props: ['open', 'meter_id', 'gateway_id'],
    computed: {
        ...mapGetters({
            getMeter: 'meters/getMeter'
        }),
    },
    data() {
        return {
            meter: {
                id: '',
                name: '',
                type: null,
            },
            error: {
                message: '',
                active: false
            },
            loading: false
        }
    },
    methods: {
        ...mapActions({
            addMeter: 'meters/addMeter',
            editMeter: 'meters/editMeter'
        }),
        async save(){
            this.loading = true
            try {
                if(!this.meter_id)
                    await this.addMeter({
                        ...this.meter,
                        gateway: this.gateway_id
                    })
                else
                    await this.editMeter(this.meter)
                
                this.close()
            } catch (error) {
                this.error.message = 'No fue posible agregar el dipositivo'
                this.error.active = true
            }
            this.loading = false
        },
        close(){
            this.meter.id = ''
            this.meter.name = ''
            this.meter.type = null
            this.$emit('close')
        }
    },
    watch: {
        meter_id(){
            if(this.meter_id){
                const meter = this.getMeter(this.meter_id)
                this.meter.id = meter.id
                this.meter.name = meter.name
                this.meter.type = meter.type
            }
        }
    }
}
</script>
